import type { HTMLAttributes } from "react";

interface AvatarProps extends HTMLAttributes<HTMLSpanElement> {
  name: string;
  size?: "sm" | "md" | "lg";
}

function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function Avatar({
  name,
  size = "md",
  className = "",
  ...props
}: AvatarProps) {
  return (
    <span
      className={`avatar avatar--${size} ${className}`.trim()}
      title={name}
      aria-hidden="true"
      {...props}
    >
      {initials(name)}
    </span>
  );
}
